export default __webpack_public_path__ + "static/media/g-record.b9460ad0.svg";